import { getAmplitudeInstance } from '../amplitudeHelpers';

type logTrailDetailsHighlightTappedParams = {
  highlight_type: string;
  index?: number;
  slug?: string;
  subtitle?: string;
  title?: string;
  trail_id: number;
};

/**
 * User taps a tappable highlight row in the Highlights section of the trail details page. Fires once per tap.
 * @param params - Attributes to log with the amplitude event
 * @param params.highlight_type - The type of the highlight tapped (e.g., 'featured_in_guide', 'spotty_service', 'great_views').
 * @param params.index - 0-indexed position of the highlight in the stack.
 * @param params.slug - Stable identifier for the specific highlight tapped (e.g., 'top_picks_yosemite_np'). Used to disambiguate highlights of the same type.
 * @param params.subtitle - Visible sub-copy text shown beneath the title (e.g., 'Top Picks in Yosemite National Park'). Optional because some highlights may not have a subtitle.
 * @param params.title - Visible title text shown on the highlight row (e.g., 'Featured in our guide').
 * @param params.trail_id - The trail id of the associated trail details page.
 */
const logTrailDetailsHighlightTapped = (
  { highlight_type, index, slug, subtitle, title, trail_id }: logTrailDetailsHighlightTappedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'trail details highlight tapped',
    { 'highlight type': highlight_type, index, slug, subtitle, title, 'trail id': trail_id },
    callback
  );
};

export default logTrailDetailsHighlightTapped;
